<div class="TotemWidget TotemWidgetCountdown card">
        <div class="card-body">
                <div class="TotemWidgetCountdown-Image">
                        <div>
                                <i class="fa-regular fa-hourglass"></i>
                                <i class="fa-regular fa-hourglass-end"></i>
                                <i class="fa-regular fa-hourglass-half"></i>
                                <i class="fa-regular fa-hourglass-end"></i>
                        </div>
                </div>
                <div>
                        <div class="TotemWidgetCountdown-Content card-text">
                                <h1 class="text-primary">{{displayCountdown}}</h1>
                                <div class="text-dark">
                                        <i class="fa-regular fa-calendar me-2 fa-lg"></i>
                                        <span>{{date | locFormat:'datetime'}}</span>
                                </div>
                        </div>
                </div>
        </div>
</div>